import { feedItems, heroStory } from '@/mocks/gossip';

export default function Hero() {
  const quick = feedItems.filter((it) => it.cat === 'quick').slice(0, 3);

  return (
    <section className="relative overflow-hidden bg-background-100/70">
      <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-background-100 to-transparent" />
      <div className="relative mx-auto max-w-7xl px-4 py-8 md:px-6 md:py-12">
        <div className="grid gap-6 lg:grid-cols-[1.55fr_1fr]">
          <article className="group relative flex min-h-[360px] flex-col justify-end overflow-hidden rounded-xl md:min-h-[460px]">
            <img
              src={heroStory.img}
              alt={heroStory.alt}
              className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/35 to-foreground-950/10" />
            <div className="absolute left-5 top-5 flex items-center gap-2">
              <span className="rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">今日头条</span>
              <span className="rounded-full bg-background-50/20 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur">
                {heroStory.kicker.split('·')[1]?.trim() ?? heroStory.kicker}
              </span>
            </div>
            <div className="relative z-10 px-5 pb-6 md:px-7 md:pb-8">
              <h2 className="max-w-2xl font-heading text-2xl font-black leading-snug text-background-50 md:text-[34px] md:leading-tight">
                {heroStory.title}
              </h2>
              <p className="mt-3 max-w-2xl text-sm leading-6 text-background-100/90 md:text-[15px]">{heroStory.desc}</p>
              <div className="mt-4 flex items-center gap-3 text-xs text-background-100/80">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-time-line" />
                  {heroStory.time}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-fire-line" />
                  图文 · 长图 · 盘点合集
                </span>
              </div>
            </div>
          </article>

          <div className="flex flex-col gap-4">
            <div className="rounded-xl bg-background-50 p-5 shadow-sm">
              <div className="mb-4 flex items-center justify-between">
                <h3 className="font-heading text-base font-bold text-foreground-950">今日速览</h3>
                <span className="inline-flex items-center gap-1 text-[11px] text-primary-600">
                  <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary-500" />
                  滚动更新中
                </span>
              </div>
              <ul className="divide-y divide-background-200">
                {quick.map((it, i) => (
                  <li key={it.id} className="flex gap-4 py-3 first:pt-0 last:pb-0">
                    <span className="font-heading text-2xl font-black text-primary-200">{String(i + 1).padStart(2, '0')}</span>
                    <div className="min-w-0">
                      <p className="text-sm font-semibold leading-snug text-foreground-900">{it.title}</p>
                      <div className="mt-1.5 flex items-center gap-3 text-[11px] text-foreground-500">
                        <span>{catL(it.cat)}</span>
                        <span>{it.time}</span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
              <a
                href="#feed"
                className="mt-4 flex items-center justify-center gap-1 rounded-md bg-secondary-100 py-2 text-sm font-medium text-foreground-800 transition hover:bg-primary-500 hover:text-background-50"
              >
                去图文合集看全部
                <i className="ri-arrow-right-line" />
              </a>
            </div>

            <div className="flex items-center gap-3 overflow-hidden rounded-xl bg-primary-500 px-5 py-4">
              <i className="ri-quill-pen-line text-2xl text-accent-200" />
              <p className="text-sm leading-snug text-background-50">
                把散落的八卦整理成<b className="font-bold text-accent-200">合集、长图、深扒、盘点</b>，热门事件一网打尽，吃瓜也有条理。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function catL(key: string) {
  const map: Record<string, string> = { quick: '速递', deep: '深扒', round: '盘点', redcarpet: '红毯', behind: '幕后' };
  return map[key] ?? '';
}